import React from "react";
import aboutImg1 from "../assets/images/about-img-1.jpg";
import contactUsImg from "../assets/images/contact-us-img.svg";
import iconFinancialStrategies from "../assets/images/icon-financial-strategies.svg";
import iconPhone from "../assets/images/icon-phone.svg";
import author1 from "../assets/images/author-1.jpg";
import whyChooseImg1 from "../assets/images/why-choose-img-1.jpg";
import whyChooseImg2 from "../assets/images/why-choose-img-2.jpg";
import iconWhyChoose1 from "../assets/images/icon-why-choose-2.svg";
import aboutImg2 from "../assets/images/about-img-2.jpg";
import ourvisionnn from "../assets/images/our-vision-img.jpg";
import ourvalueimg from "../assets/images/our-value-img.jpg";
import iconourfeature1 from "../assets/images/icon-our-feature-1.svg";
import iconourfeature2 from "../assets/images/icon-our-feature-2.svg";
import iconourfeature3 from "../assets/images/icon-our-feature-3.svg";
import iconourfeature4 from "../assets/images/icon-our-feature-4.svg";
import iconourfeature5 from "../assets/images/icon-our-feature-5.svg";
import iconourfeature6 from "../assets/images/icon-our-feature-6.svg";
import ourbenefit from "../assets/images/our-benefit-img.jpg";
import ourbenefit1 from "../assets/images/icon-our-benefit-1.svg";
import ourbenefit2 from "../assets/images/icon-our-benefit-2.svg";
import ourbenefit3 from "../assets/images/icon-our-benefit-3.svg";
import ourbenefit4 from "../assets/images/icon-our-benefit-4.svg";
import faqsimg from "../assets/images/faqs-img.jpg";
import faqsimsatisfyclientimg1 from "../assets/images/satisfy-client-img-1.jpg";
import faqsimsatisfyclientimg2 from "../assets/images/satisfy-client-img-2.jpg";
import faqsimsatisfyclientimg3 from "../assets/images/satisfy-client-img-3.jpg";
import faqsimsatisfyclientimg4 from "../assets/images/satisfy-client-img-4.jpg";
import faqsimsatisfyclientimg5 from "../assets/images/satisfy-client-img-5.jpg";
import whatwedoimg2 from "../assets/images/what-we-do-img-2.jpg";
import whatwedoimg from "../assets/images/what-we-do-img-1.jpg";
import ourmissionimg from "../assets/images/our-mission-img.jpg";

function About() {
  return (
    <>
      <div className="page-header">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              {/* Page Header Box Start */}
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">
                  About us
                </h1>
                <nav className="wow fadeInUp">
                  {/* <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="./">home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  about us
                </li>
              </ol> */}
                </nav>
              </div>
              {/* Page Header Box End */}
            </div>
          </div>
        </div>
      </div>
      {/* Page Header End */}
      {/* About Us Section Start */}
      <div className="about-us">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              {/* About Us Images Start */}
              <div className="about-us-images">
                {/* About Image 1 Start */}
                <div className="about-img-1">
                  <figure className="image-anime reveal">
                    <img src={aboutImg1} alt="aboutImg1" />
                  </figure>
                </div>
                {/* About Image 1 End */}
                {/* About Image 2 Start */}
                <div className="about-img-2">
                  <figure className="image-anime reveal">
                    <img src={aboutImg2} alt="aboutImg2" />
                  </figure>
                </div>
                {/* About Image 2 End */}
                {/* Contact Circle Start */}
                <div className="contact-circle">
                  <img src={contactUsImg} alt="contactUsImg" />
                </div>
                {/* Contact Circle End */}
              </div>
              {/* About Us Images End */}
            </div>
            <div className="col-lg-6">
              {/* About Us Content Start */}
              <div className="about-us-content">
                {/* Section Title Start */}
                <div className="section-title">
                  <h3 className="wow fadeInUp">about us</h3>
                  <h2 className="text-anime-style-2">
                    Trusted guidance for <span>financial growth</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    With years of expertise in finance and consulting, we
                    provide tailored strategies to help you achieve sustainable
                    growth. Our commitment is to guide you integrity, insight,
                    and a personalized approach.
                  </p>
                </div>
                {/* Section Title End */}
                {/* About Content body Start */}
                <div className="about-content-body">
                  <div className="row align-items-center">
                    <div className="col-md-12">
                      {/* About Content Info Start */}
                      <div className="about-content-info">
                        {/* About Goal Box Start */}
                        <div
                          className="flexone about-goal-box wow fadeInUp"
                          data-wow-delay="0.4s"
                        >
                          <div className="icon-box">
                            <img
                              src={iconFinancialStrategies}
                              alt="iconFinancialStrategies"
                            />
                          </div>
                          <div className=" about-goal-box-content">
                            <h3>financial strategies</h3>
                            <p>
                              Tailored plans to meet your unique financial needs
                              and goals.
                            </p>
                          </div>
                        </div>
                        {/* About Goal Box End */}
                        {/* About Contact Box Start */}
                        <div
                          className="flexone about-goal-box  wow fadeInUp"
                          data-wow-delay="0.6s"
                        >
                          <div className="icon-box">
                            <img
                              src={iconPhone}
                              alt="iconFinancialStrategies"
                            />
                          </div>

                          <div className=" about-goal-box-content">
                            <h3>Contact Number</h3>
                            <a href="tel:+91-9079132001">+91-9079132001</a>
                          </div>
                        </div>
                        {/* About Contact Box End */}
                      </div>
                      {/* About Content Info End */}
                    </div>
                    <div className="col-md-12">
                      {/* About Author Box Start */}
                      <div
                        className="about-author-box wow fadeInUp"
                        data-wow-delay="0.4s"
                      >
                        {/* About Info Box Start */}
                        <div className="about-info-box">
                          <figure className="image-anime reveal">
                            <img src={author1} alt="author1" />
                          </figure>
                          <div className="about-author-content">
                            <h3>Sarah T.</h3>
                            <p>Co. founder</p>
                          </div>
                        </div>
                        {/* About Info Box End */}
                        {/* About Info List Start */}
                        <div className="about-info-list">
                          <ul>
                            <li>risk management</li>
                            <li>communication</li>
                            <li>24/7 support</li>
                          </ul>
                        </div>
                        {/* About Info List End */}
                      </div>
                      {/* About Author Box End */}
                    </div>
                  </div>
                </div>
                {/* About Content body End */}
              </div>
              {/* About Us Content End */}
            </div>
          </div>
        </div>
      </div>
      {/* About Us Section End */}
      {/* Our Approach Section Start */}
      <div className="our-approach">
        <div className="container">
          <div className="row section-row align-items-center">
            <div className="col-lg-6">
              {/* Section Title Start */}
              <div className="section-title">
                <h3 className="wow fadeInUp">our approach</h3>
                <h2 className="wow fadeInUp" data-wow-delay="0.2s">
                  Customized strategies for <span>financial success</span>
                </h2>
              </div>
              {/* Section Title End */}
            </div>
            <div className="col-lg-6">
              {/* Section Btn Start */}
              <div className="section-btn wow fadeInUp" data-wow-delay="0.2s">
                <a href="contact.html" className="btn-default">
                  Contact now
                </a>
              </div>
              {/* Section Btn Start */}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              {/* Mission Vision Item Start */}
              <div className="mission-vission-item wow fadeInUp">
                {/* Mission Vision Header Start */}
                <div className="mission-vission-header">
                  {/* <div className="icon-box">
                <img src={mission} alt="mission" />
              </div> */}
                  <div className="mission-vission-content">
                    <h3>our mission</h3>
                    <p>
                      To empower businesses and individuals with secure, fast,
                      and innovative Click4pay solutions that simplify financial
                      transactions.
                    </p>
                  </div>
                </div>
                {/* Mission Vision Header End */}
                {/* Mission Vision Image Start */}
                <div className="mission-vission-image">
                  <figure className="image-anime">
                    <img src={ourmissionimg} alt="ourmissionimg" />
                  </figure>
                </div>
                {/* Mission Vision Image End */}
              </div>
              {/* Mission Vision Item End */}
            </div>
            <div className="col-lg-4 col-md-6">
              {/* Mission Vision Item Start */}
              <div
                className="mission-vission-item wow fadeInUp"
                data-wow-delay="0.2s"
              >
                {/* Mission Vision Header Start */}
                <div className="mission-vission-header">
                  {/* <div className="icon-box">
                <img src={ourvision} alt="ourvision" />
              </div> */}
                  <div className="mission-vission-content">
                    <h3>our vision</h3>
                    <p>
                      A trusted global fintech partner, enabling seamless
                      digital financial inclusion, and empowering sustainable
                      growth for all.
                    </p>
                  </div>
                </div>
                {/* Mission Vision Header End */}
                {/* Mission Vision Image Start */}
                <div className="mission-vission-image">
                  <figure className="image-anime">
                    <img src={ourvisionnn} alt="ourvisionnn" />
                  </figure>
                </div>
                {/* Mission Vision Image End */}
              </div>
              {/* Mission Vision Item End */}
            </div>
            <div className="col-lg-4 col-md-6">
              {/* Mission Vision Item Start */}
              <div
                className="mission-vission-item wow fadeInUp"
                data-wow-delay="0.4s"
              >
                {/* Mission Vision Header Start */}
                <div className="mission-vission-header">
                  {/* <div className="icon-box">
                <img src={iconourvalue} alt="iconourvalue" />
              </div> */}
                  <div className="mission-vission-content">
                    <h3>our value</h3>
                    <p>
                      Innovation, Integrity, and Customer Success guide
                      everything we do — ensuring transparency, security, and
                      long-term partnerships.
                    </p>
                  </div>
                </div>
                {/* Mission Vision Header End */}
                {/* Mission Vision Image Start */}
                <div className="mission-vission-image">
                  <figure className="image-anime">
                    <img src={ourvalueimg} alt="ourvalueimg" />
                  </figure>
                </div>
                {/* Mission Vision Image End */}
              </div>
              {/* Mission Vision Item End */}
            </div>
          </div>
        </div>
      </div>
      {/* Our Approach Section End */}
      {/* Why Choose Us Section Start */}
      <div className="why-choose-us">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              {/* Why Choose Content Start */}
              <div className="why-choose-content">
                {/* Section Title Start */}
                <div className="section-title">
                  <h3 className="wow fadeInUp">why choose us</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Why trust us <span>our finances</span>
                  </h2>
                </div>
                {/* Section Title End */}
                {/* Why Choose Box List Start */}
                <div className="why-choose-box-list">
                  {/* Why Choose Box Start */}
                  <div
                    className="why-choose-box wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div className="icon-box">
                      <img src={iconWhyChoose1} alt="iconWhyChoose1" />
                    </div>
                    <div className="why-choose-box-content">
                      <h3>Secure & Scalable Technology</h3>
                      <p>
                        Our Click4pay solutions are built on robust security
                        frameworks and scalable infrastructure, ensuring your
                        business can grow confidently without compromising on
                        safety.
                      </p>
                    </div>
                  </div>
                  {/* Why Choose Box End */}
                  {/* Why Choose Box Start */}
                  <div
                    className="why-choose-box wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div className="icon-box">
                      <img src={iconWhyChoose1} alt="iconWhyChoose1" />
                    </div>
                    <div className="why-choose-box-content">
                      <h3>Customer-Centric Approach</h3>
                      <p>
                        We design our services with your success in mind —
                        providing seamless user experiences, 24/7 support, and
                        innovative tools that make financial operations simple
                        and efficient.
                      </p>
                    </div>
                  </div>
                  {/* Why Choose Box End */}
                </div>
                {/* Why Choose Box List End */}
                {/* Why Choose List Start */}
                <div
                  className="why-choose-list wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <ul>
                    <li>strategic financial planning</li>
                    <li>expert investment advisory</li>
                  </ul>
                </div>
                {/* Why Choose List End */}
              </div>
              {/* Why Choose Content End */}
            </div>
            <div className="col-lg-6">
              {/* Why Choose Image Start */}
              <div className="why-choose-image">
                {/* Why Choose Image 1 Start */}
                <div className="why-choose-img-1">
                  <figure className="image-anime reveal">
                    <img src={whyChooseImg1} alt="whyChooseImg1" />
                  </figure>
                </div>
                {/* Why Choose Image 1 End */}
                {/* Why Choose Image 2 Start */}
                <div className="why-choose-img-2">
                  <figure className="image-anime reveal">
                    <img src={whyChooseImg2} alt="whyChooseImg2" />
                  </figure>
                </div>
                {/* Why Choose Image 2 End */}
                {/* Why Choose Contact Circle Start */}
                <div className="why-choose-contact-circle">
                  <img src={contactUsImg} alt="contactUsImg" />
                </div>
                {/* Why Choose Contact Circle Start */}
              </div>
              {/* Why Choose Image End */}
            </div>
          </div>
        </div>
      </div>
      {/* Why Choose Us Section End */}
      {/* Our Feature Section Stat */}
      <div className="our-feature">
        <div className="container">
          <div className="row section-row align-items-center">
            <div className="col-lg-6">
              {/* Section Title Start */}
              <div className="section-title dark-section">
                <h3 className="wow fadeInUp">our feature</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  Key features of our finance <span>and consulting</span>
                </h2>
              </div>
              {/* Section Title End */}
            </div>
            <div className="col-lg-6">
              {/* Section Button Start */}
              <div className="section-btn wow fadeInUp" data-wow-delay="0.2s">
                <a href="contact.html" className="btn-default">
                  contact now
                </a>
              </div>
              {/* Section Button End */}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              {/* Our Feature List Start */}
              <div className="our-feature-list">
                {/* Feature Item Start */}
                <div className="our-feature-item wow fadeInUp">
                  <div className="icon-box">
                    <img src={iconourfeature1} alt="iconourfeature1" />
                  </div>
                  <div className="feature-item-content">
                    <h3>Seamless Integration</h3>
                    <p>
                      Easily connect our fintech solutions with your existing
                      systems for a hassle-free experience.
                    </p>
                  </div>
                </div>
                {/* Feature Item End */}
                {/* Feature Item Start */}
                <div
                  className="our-feature-item wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <div className="icon-box">
                    <img src={iconourfeature2} alt="iconourfeature2" />
                  </div>
                  <div className="feature-item-content">
                    <h3>High Security Standards</h3>
                    <p>
                      End-to-end encryption and fraud detection ensure every
                      transaction is safe.
                    </p>
                  </div>
                </div>
                {/* Feature Item End */}
                {/* Feature Item Start */}
                <div
                  className="our-feature-item wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <div className="icon-box">
                    <img src={iconourfeature3} alt="iconourfeature3" />
                  </div>
                  <div className="feature-item-content">
                    <h3>Real-Time Processing</h3>
                    <p>
                      Instant payments, settlements, and updates keep your
                      business running smoothly.
                    </p>
                  </div>
                </div>
                {/* Feature Item End */}
                {/* Feature Item Start */}
                <div
                  className="our-feature-item wow fadeInUp"
                  data-wow-delay="0.6s"
                >
                  <div className="icon-box">
                    <img src={iconourfeature4} alt="iconourfeature4" />
                  </div>
                  <div className="feature-item-content">
                    <h3>Customizable Solutions</h3>
                    <p>
                      Tailored fintech products to match your business model and
                      customer needs.
                    </p>
                  </div>
                </div>
                {/* Feature Item End */}
                {/* Feature Item Start */}
                <div
                  className="our-feature-item wow fadeInUp"
                  data-wow-delay="0.8s"
                >
                  <div className="icon-box">
                    <img src={iconourfeature5} alt="iconourfeature5" />
                  </div>
                  <div className="feature-item-content">
                    <h3>24/7 Support</h3>
                    <p>
                      Dedicated technical and customer support whenever you need
                      assistance.
                    </p>
                  </div>
                </div>
                {/* Feature Item End */}
                {/* Feature Item Start */}
                <div
                  className="our-feature-item wow fadeInUp"
                  data-wow-delay="1s"
                >
                  <div className="icon-box">
                    <img src={iconourfeature6} alt="iconourfeature6" />
                  </div>
                  <div className="feature-item-content">
                    <h3>Analytics & Insights</h3>
                    <p>
                      Smart dashboards and reports help you make data-driven
                      business decisions.
                    </p>
                  </div>
                </div>
                {/* Feature Item End */}
              </div>
              {/* Our Feature List End */}
            </div>
            <div className="col-lg-12">
              {/* Our Featured Footer Start */}
              <div
                className="our-feature-footer wow fadeInUp"
                data-wow-delay="1.2s"
              >
                <p>
                  <span>Free</span> Let's make something great work together.{" "}
                  <a href="contact.html">Get Free Quote</a>
                </p>
              </div>
              {/* Our Featured Footer End */}
            </div>
          </div>
        </div>
      </div>
      {/* Our Feature Section End */}
      {/* Our Benefit Section Start */}

      <div className="our-benefit">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              {/* Our Benefit Content Start */}
              <div className="our-benefit-content">
                {/* Section Title Start */}
                <div className="section-title">
                  <h3 className="wow fadeInUp">our benefits</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Maximizing value expert <span>financial solutions</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    Unlocking growth opportunities with tailored financial
                    strategies for maximum value and long-term success.
                  </p>
                </div>
                {/* Section Title End */}
                {/* Our Benefit Button Start */}
                <div
                  className="our-benefit-btn wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <a href="contact.html" className="btn-default">
                    get started
                  </a>
                </div>
                {/* Our Benefit Button End */}
                <div className="our-benefit-img">
                  <figure className="image-anime reveal">
                    <img src={ourbenefit} alt="ourbenefit" />
                  </figure>
                </div>
              </div>
              {/* Our Benefit Content End */}
            </div>
            <div className="col-lg-6">
              {/* Our Benefit Box Start */}
              <div className="our-benefit-box">
                {/* Our Benefit List Start */}
                <div className="our-benefit-list">
                  {/* Our Benefit Item Start */}
                  <div className="our-benefit-item wow fadeInUp">
                    <div className="icon-box">
                      <img src={ourbenefit1} alt="ourbenefit1" />
                    </div>
                    <div className="benefit-item-content">
                      <h3>expert guidance</h3>
                      <p>
                        Benefit from our team’s deep fintech expertise,
                        providing tailored solutions and reliable support to
                        help you make the right financial decisions.
                      </p>
                    </div>
                  </div>
                  {/* Our Benefit Item End */}
                  {/* Our Benefit Item Start */}
                  <div
                    className="our-benefit-item wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div className="icon-box">
                      <img src={ourbenefit2} alt="ourbenefit2" />
                    </div>
                    <div className="benefit-item-content">
                      <h3>risk management</h3>
                      <p>
                        Stay protected with advanced security frameworks, fraud
                        detection, and compliance-driven processes designed to
                        minimize risks.
                      </p>
                    </div>
                  </div>
                  {/* Our Benefit Item End */}
                  {/* Our Benefit Item Start */}
                  <div
                    className="our-benefit-item wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    <div className="icon-box">
                      <img src={ourbenefit3} alt="ourbenefit3" />
                    </div>
                    <div className="benefit-item-content">
                      <h3>long-term growth</h3>
                      <p>
                        Our scalable solutions are built to adapt as your
                        business expands, ensuring sustainable financial success
                        over time.
                      </p>
                    </div>
                  </div>
                  {/* Our Benefit Item End */}
                  {/* Our Benefit Item Start */}
                  <div
                    className="our-benefit-item wow fadeInUp"
                    data-wow-delay="0.6s"
                  >
                    <div className="icon-box">
                      <img src={ourbenefit4} alt="ourbenefit4" />
                    </div>
                    <div className="benefit-item-content">
                      <h3>time efficiency</h3>
                      <p>
                        Save valuable time with automated processes, real-time
                        transactions, and easy integrations that streamline
                        operations.
                      </p>
                    </div>
                  </div>
                  {/* Our Benefit Item End */}
                </div>
                {/* Our Benefit List End */}
                {/* Our Benefit Get Quote Text Start */}
                <div
                  className="our-benefit-get-quote wow fadeInUp"
                  data-wow-delay="0.8s"
                >
                  <p>
                    {" "}
                    Let's make something great work together.{" "}
                    <a href="#">Get Free Quote</a>
                  </p>
                </div>
                {/* Our Benefit Get Quote Text End */}
              </div>
              {/* Our Benefit Box End */}
            </div>
          </div>
        </div>
      </div>

      {/* Our Benefit Section End */}
      {/* What We Do Section Start */}
      <div className="what-we-do">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              {/* What We Do Content Start */}
              <div className="what-we-do-content">
                {/* Section Title Start */}
                <div className="section-title">
                  <h3 className="wow fadeInUp">what we do</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Driving financial growth <span>and success</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    We provide expert financial and consulting solutions
                    designed to foster growth, stability, and long-term success.
                  </p>
                </div>
                {/* Section Title End */}
                {/* What We Do List Start */}
                <div
                  className="what-we-do-list wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <ul>
                    <li>strategic financial planning</li>
                    <li>expert investment advisory</li>
                    <li>risk assessment &amp; mitigation</li>
                    <li>retirement &amp; future planning</li>
                  </ul>
                </div>
                {/* What We Do List End */}
                {/* What We Do Button Start */}
                <div
                  className="what-we-do-btn wow fadeInUp"
                  data-wow-delay="0.6s"
                >
                  <a href="contact.html" className="btn-default">
                    contact now
                  </a>
                </div>
                {/* What We Do Button End */}
              </div>
              {/* What We Do Content End */}
            </div>
            <div className="col-lg-6">
              {/* What We Do Images Start */}
              <div className="what-we-do-images">
                {/* What We Do Image 1 Start */}
                <div className="what-do-we-img-1">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg} alt="whatwedoimg" />
                  </figure>
                </div>
                {/* What We Do Image 1 End */}
                {/* What We Do Image 2 Start */}
                <div className="what-do-we-img-2">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg2} alt="whatwedoimg2" />
                  </figure>
                </div>
                {/* What We Do Image 2 End */}
                {/* Experience Counter Box Start */}
                <div className="experience-counter-box">
                  <div className="experience-counter-no">
                    <h2>
                      <span className="counter">5</span>+
                    </h2>
                  </div>
                  <div className="experience-counter-content">
                    <p>Years of experience in finance</p>
                  </div>
                </div>
                {/* Experience Counter Box Start End */}
              </div>
              {/* What We Do Images End */}
            </div>
          </div>
        </div>
      </div>
      {/* What We Do Section End */}
      {/* How It Work Section Start */}
      <div className="how-it-work">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              {/* How It Work Content Start */}
              <div className="how-it-work-content">
                {/* Section Title Start */}
                <div className="section-title">
                  <h3 className="wow fadeInUp">how it work</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Our process for financial <span>success</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    Our process is designed to guide you every step of the way.
                    From initial consultation to personalized strategy
                    development.
                  </p>
                </div>
                {/* Section Title End */}
                {/* How It Work Button Start */}
                <div
                  className="how-it-work-btn wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <a href="contact.html" className="btn-default">
                    learn more
                  </a>
                </div>
                {/* How It Work Button End */}
              </div>
              {/* How It Work Content End */}
            </div>
            <div className="col-lg-6">
              {/* Work Steps Box Start */}
              <div className="work-steps-box">
                {/* Work Steps Item Start */}
                <div className="work-step-item wow fadeInUp">
                  <div className="work-step-item-content">
                    <h3>step</h3>
                    <h2>Sign Up & Get Started</h2>
                    <p>
                      Create your Click4pay account in minutes and access our
                      secure fintech platform.
                    </p>
                  </div>
                  <div className="work-step-item-no">
                    <h2>01</h2>
                  </div>
                </div>
                {/* Work Steps Item End */}
                {/* Work Steps Item Start */}
                <div
                  className="work-step-item wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <div className="work-step-item-content">
                    <h3>step</h3>
                    <h2>Integrate & Customize</h2>
                    <p>
                      Connect our payment and financial solutions with your
                      business, tailored to your needs.
                    </p>
                  </div>
                  <div className="work-step-item-no">
                    <h2>02</h2>
                  </div>
                </div>
                {/* Work Steps Item End */}
                {/* Work Steps Item Start */}
                <div
                  className="work-step-item wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <div className="work-step-item-content">
                    <h3>step</h3>
                    <h2>Transact & Grow</h2>
                    <p>
                      Start accepting payments, managing finances, and scaling
                      your business with real-time insights.
                    </p>
                  </div>
                  <div className="work-step-item-no">
                    <h2>03</h2>
                  </div>
                </div>
                {/* Work Steps Item End */}
              </div>
              {/* Work Steps Box End */}
            </div>
          </div>
        </div>
      </div>
      {/* How It Work Section End */}
      {/* Our Partners Section Start */}

      {/* Our Partners Section End */}
      {/* Our Team Section Start */}

      {/* Our Team Section End */}
      {/* Our Testimonial Section Start */}

      {/* Our Testimonial Section End */}
      {/* Our FAQs Section Start*/}
      <div className="our-faqs">
        <div className="container">
          <div className="row section-row align-items-center">
            <div className="col-lg-6">
              {/* Section Title Start */}
              <div className="section-title">
                <h3 className="wow fadeInUp">faqs</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  Your most frequently asked <span>questions answered</span>
                </h2>
              </div>
              {/* Section Title End */}
            </div>
            <div className="col-lg-6">
              {/* Section Button Start */}
              <div className="section-btn">
                <a href="faqs.html" className="btn-default">
                  view all FAQs
                </a>
              </div>
              {/* Section Button End */}
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-6">
              {/* Our FAQs Image Start */}
              <div className="our-faqs-image">
                {/* Our FAQs Img Start */}
                <div className="our-faqs-img">
                  <figure className="image-anime reveal">
                    <img src={faqsimg} alt="faqsimg" />
                  </figure>
                </div>
                {/* Our FAQs Img End */}
                {/* Client Review Box Start */}
                <div className="client-review-box">
                  {/* Client Review Box Content Start */}
                  <div className="client-review-box-content">
                    <p>
                      100+ Client{" "}
                      <span>
                        <i className="fa-solid fa-star" /> 5.0 (250 Reviews)
                      </span>
                    </p>
                  </div>
                  {/* Client Review Box Content End */}
                  {/* Client Review Images Start */}
                  <div className="client-review-images">
                    {/* Client Image Start */}
                    <div className="client-image">
                      <figure className="image-anime">
                        <img
                          src={faqsimsatisfyclientimg1}
                          alt="faqsimsatisfyclientimg1"
                        />
                      </figure>
                    </div>
                    {/* Client Image End */}
                    {/* Client Image Start */}
                    <div className="client-image">
                      <figure className="image-anime">
                        <img
                          src={faqsimsatisfyclientimg2}
                          alt="faqsimsatisfyclientimg2"
                        />
                      </figure>
                    </div>
                    {/* Client Image End */}
                    {/* Client Image Start */}
                    <div className="client-image">
                      <figure className="image-anime">
                        <img
                          src={faqsimsatisfyclientimg3}
                          alt="faqsimsatisfyclientimg3"
                        />
                      </figure>
                    </div>
                    {/* Client Image End */}
                    {/* Client Image Start */}
                    <div className="client-image">
                      <figure className="image-anime">
                        <img
                          src={faqsimsatisfyclientimg4}
                          alt="faqsimsatisfyclientimg4"
                        />
                      </figure>
                    </div>
                    {/* Client Image End */}
                    {/* Client Image Start */}
                    <div className="client-image">
                      <figure className="image-anime">
                        <img
                          src={faqsimsatisfyclientimg5}
                          alt="faqsimsatisfyclientimg5"
                        />
                      </figure>
                    </div>
                    {/* Client Image End */}
                    {/* Add More Client Image Start */}
                    <div className="client-image add-more">
                      <p>
                        <span className="counter">30</span>+
                      </p>
                    </div>
                    {/* Add More Client Image End */}
                  </div>
                  {/* Client Review Images End */}
                </div>
                {/* Client Review Box End */}
              </div>
              {/* Our FAQs Image End */}
            </div>
            <div className="col-lg-6">
              {/* Our FAQ Section Start */}
              <div className="our-faq-section">
                {/* FAQ Accordion Start */}
                <div className="faq-accordion" id="faqaccordion">
                  {/* Accordion Item Start */}
                  <div className="accordion-item wow fadeInUp">
                    <h2 className="accordion-header" id="heading1">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapse1"
                        aria-expanded="true"
                        aria-controls="collapse1"
                      >
                        What services do you offer?
                      </button>
                    </h2>
                    <div
                      id="collapse1"
                      className="accordion-collapse collapse"
                      aria-labelledby="heading1"
                      data-bs-parent="#faqaccordion"
                    >
                      <div className="accordion-body">
                        <p>
                          If you're uncertain about managing investments,
                          planning for retirement, or structuring your finances,
                          consulting a financial professional can help. Our team
                          assists in clarifying your goals, optimizing your
                          strategies.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Accordion Item End */}
                  {/* Accordion Item Start */}
                  <div
                    className="accordion-item wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <h2 className="accordion-header" id="heading2">
                      <button
                        className="accordion-button "
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapse2"
                        aria-expanded="false"
                        aria-controls="collapse2"
                      >
                        How do I know if I need a financial consultant?
                      </button>
                    </h2>
                    <div
                      id="collapse2"
                      className="accordion-collapse collapse show"
                      aria-labelledby="heading2"
                      data-bs-parent="#faqaccordion"
                    >
                      <div className="accordion-body">
                        <p>
                          If you're uncertain about managing investments,
                          planning for retirement, or structuring your finances,
                          consulting a financial professional can help. Our team
                          assists in clarifying your goals, optimizing your
                          strategies.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Accordion Item End */}
                  {/* Accordion Item Start */}
                  <div
                    className="accordion-item wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    <h2 className="accordion-header" id="heading3">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapse3"
                        aria-expanded="false"
                        aria-controls="collapse3"
                      >
                        What can I expect from an initial consultation?
                      </button>
                    </h2>
                    <div
                      id="collapse3"
                      className="accordion-collapse collapse"
                      aria-labelledby="heading3"
                      data-bs-parent="#faqaccordion"
                    >
                      <div className="accordion-body">
                        <p>
                          If you're uncertain about managing investments,
                          planning for retirement, or structuring your finances,
                          consulting a financial professional can help. Our team
                          assists in clarifying your goals, optimizing your
                          strategies.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Accordion Item End */}
                  {/* Accordion Item Start */}
                  <div
                    className="accordion-item wow fadeInUp"
                    data-wow-delay="0.6s"
                  >
                    <h2 className="accordion-header" id="heading4">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapse4"
                        aria-expanded="false"
                        aria-controls="collapse4"
                      >
                        Are my consultations confidential?
                      </button>
                    </h2>
                    <div
                      id="collapse4"
                      className="accordion-collapse collapse"
                      aria-labelledby="heading4"
                      data-bs-parent="#faqaccordion"
                    >
                      <div className="accordion-body">
                        <p>
                          If you're uncertain about managing investments,
                          planning for retirement, or structuring your finances,
                          consulting a financial professional can help. Our team
                          assists in clarifying your goals, optimizing your
                          strategies.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Accordion Item End */}
                  {/* Accordion Item Start */}
                  <div
                    className="accordion-item wow fadeInUp"
                    data-wow-delay="0.8s"
                  >
                    <h2 className="accordion-header" id="heading5">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapse5"
                        aria-expanded="false"
                        aria-controls="collapse5"
                      >
                        What kind of clients do you work with?
                      </button>
                    </h2>
                    <div
                      id="collapse5"
                      className="accordion-collapse collapse"
                      aria-labelledby="heading5"
                      data-bs-parent="#faqaccordion"
                    >
                      <div className="accordion-body">
                        <p>
                          If you're uncertain about managing investments,
                          planning for retirement, or structuring your finances,
                          consulting a financial professional can help. Our team
                          assists in clarifying your goals, optimizing your
                          strategies.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Accordion Item End */}
                </div>
                {/* FAQ Accordion End */}
              </div>
              {/* Our FAQ Section End */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
